<template>
    <div class="jumppage" >
        <img  src="/assets/~/media/images/activity/film2505-prod/pc/GPIC.jpg" alt="" />
        <!-- 两个了解车型 按钮 -->
        <div class="button-ev5 button-jump" @click="gotoEv5"
        code-ga="event, PAGEURL, 了解车型_2025款Ev5"
              code-stm="event, PAGEURL, 了解车型_2025款Ev5"></div>
        <div class="button-spotage button-jump" @click="gotoSpotage"
        code-ga="event, PAGEURL, 了解车型_2025款狮铂拓界"
        code-stm="event, PAGEURL, 了解车型_2025款狮铂拓界"></div>
    </div>
</template>

<script>
// import Swiper from "./Swiper";
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";

export default {
    data() {
        return {
            isPortrait: isPortraitFun(),
            minip: false,
            preText: 'https://www.kia.cn',
        };
    },
    // components: { Swiper },
    mounted: function () {
        if (!window.location.href.includes("https://www.kia.cn")) {
            this.preText = 'https://uat.kia.cn'
        } else {
            this.preText = 'https://www.kia.cn'
        }
        if (getUrlKey("minip")) {
            this.minip = true;
        }
        new Swiper(".mySwiper-kv", {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
            loop: true,
            loopFillGroupWithBlank: true,
            pagination: {
                el: ".swiper-pagination-kv",
                clickable: true,
            },
            navigation: {
                nextEl: "#swiper-button-next-kv",
                prevEl: "#swiper-button-prev-kv",
            },
            on: {
                slideChangeTransitionEnd: this.slideChangeTransitionEnd,
            },
        });
    },
    methods: {
        gotoEv5() {
            window.open(this.preText + '/vehicles/ev5/', '_blank');
        },
        gotoSpotage() {
            window.open(this.preText + '/vehicles/sportage/', '_blank');
        },
        custormAnchor(anchorName) {
            // window.location = "https://www.kia.cn/activity/2022/08/nq5cpay/7yhegE3/index.html#/?utm_source=&utm_soid=&utm_activity=&mz_ca=&mz_sp="
            this.$parent.directToMove(anchorName);
            // // 找到锚点
            // let anchorElement = document.getElementById(anchorName);
            // // 如果对应id的锚点存在，就跳转到锚点
            // if(anchorElement) { anchorElement.scrollIntoView(); }
        },
        clickPlayIcon: function () {
            let swiperIndex = this.$refs.kiaSwiper.swiper.activeIndex;
            let dom;
            switch (swiperIndex) {
                case 0:
                    dom = document.querySelector(".thirdpage");
                    dom.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                        inline: "nearest",
                    });
                    break;
                case 1:
                    dom = document.querySelector(".fourpage");
                    dom.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                        inline: "nearest",
                    });
                    break;
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";

.jumppage {
    position: relative;
    width: 100%;
    user-select: none;
    z-index: 0;
    height: calc(1238 / 2200 * 100vw);
    .logo-box {
        z-index: 30 !important;
        position: absolute;
        left: 6vw;
        top: 7.3vh;
        z-index: 3;
        img {
        width: 139px;
        object-fit: cover;
        }
    }
    img {
        @media (max-width:767px) {
            margin-bottom: -1px;
        }
        height: 100%;
        width: 100%;
    }
    .button-jump {
        position: absolute;
    }
    .button-ev5 {
        left: calc(360 / 2200 * 100vw);
        top: calc(236 / 2200 * 100vw);
        width: calc(693 / 2200 * 100vw);
        height: calc(686 / 2200 * 100vw);
        cursor: pointer;
    } 
    .button-spotage {
        left: calc(1138 / 2200 * 100vw);
        top: calc(375 / 2200 * 100vw);
        width: calc(692 / 2200 * 100vw);
        height: calc(686 / 2200 * 100vw);
        cursor: pointer;
    }
    
    .icons {
        .playicon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
            background: url("../../assets/images/play.png") no-repeat;
            z-index: 10;
            cursor: pointer;
        }
    }

    .txt-container {
        width: 21%;
        position: absolute;
        left: 12%;
        top: 13%;
        // .btn-container {
        //   display: flex;
        //   justify-content: space-between;
        //   width: 100%;
        //   margin-top: 8%;
        //   a {
        //     width: 48%;
        //   }
        // }
    }

    .city {
        width: 20%;
        position: absolute;
        bottom: 15vh;
        left: 12%;
    }

    .swiper-button-prev,
    .swiper-button-next {
        position: absolute;
        color: #fff;
    }

    ::v-deep .swiper-pagination-bullet {
        width: 40px;
        height: 2px;
        display: inline-block;
        border-radius: 0;
        background: #fff;
        color: #fff;
        opacity: 1;
    }

    ::v-deep .swiper-pagination-bullet-active {
        background: #000;
    }

    ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
        bottom: 40px;
        left: 30px;
        width: 100%;
        position: absolute;
        color: #fff;
        z-index: 1;
    }

    @media screen and (orientation: portrait) {
        position: relative;
        // height: calc(2350 / 390 * 100vw);
        // height: 2514px;
        width: 100%;
        user-select: none no-repeat;

        .txt-container {
            // margin-top: 5%;
            position: absolute;
            top: 7%;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            //   .btn-container {
            //     display: flex;
            //     justify-content: space-between;
            //     width: 100%;
            //     margin-top: 5%;
            //   }
        }

        .city {
            width: 45%;
            position: absolute;
            bottom: 16vh;
            left: 50%;
            transform: translateX(-50%);
        }

        ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
            bottom: 15vh;
        }
    }
}
</style>